import { render, staticRenderFns } from "./KisiselIliskiAlacakForm.vue?vue&type=template&id=de550f6e"
import script from "./KisiselIliskiAlacakForm.vue?vue&type=script&lang=ts"
export * from "./KisiselIliskiAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports